const variantsData = (product, aggregateRating) => {
  // return product?.skus.map(variant => ({
  const variant = product?.skus[0]; // Google doesn't accept large data structures, so we only take the first variant
  if (!variant) return null;

  return {
    "@type": "Offer",
    "availability": variant.available ? "https://schema.org/InStock" : "https://schema.org/OutOfStock",
    "price": String(Number(variant.price).toFixed(2)),
    "priceCurrency": window.theme.currency,
    "sku": variant.custom_fields?.skuCode || '',
    "gtin13": variant.custom_fields?.gtin || '',
    // "itemOffered": {
    //   "@type": "Product",
    //   "name": product.name.replace(/"/g, '\\"') + ' ' + variant.name.replace(/"/g, '\\"'),
    //   "sku": variant.custom_fields?.skuCode || '',
    //   "gtin13": variant.custom_fields?.gtin || '',
    //   "image": variant.image_url,
    //   ...(aggregateRating && { aggregateRating })
    // }
  };
  // }));
};

export default (products) => {
  // console.log('products', products);
  const collection_seo = document.querySelector('.collection-seo');
  const collection_title = (collection_seo) ? collection_seo.querySelector('.collection-seo__title')?.textContent.trim().replace(/"/g, '\\"') : document.getElementById('collection-heading')?.textContent.trim().replace(/"/g, '\\"');
  const collection_description = (collection_seo) ? collection_seo.querySelector('.collection-seo__description')?.textContent.trim().replace(/"/g, '\\"') : window.theme.strings.collectionPageDescription.replace(/"/g, '\\"');
  const collection_url = window.location.origin + window.location.pathname;
  
  const itemListElement = products.map((product, index) => {
    // Extract aggregateRating from custom_fields if available
    let aggregateRating;
    if (
      product.custom_fields &&
      (product.custom_fields['okendo-summarydata'] || product.custom_fields['okendo-summaryData'])
    ) {
      const summaryData = product.custom_fields['okendo-summarydata'] || product.custom_fields['okendo-summaryData'];
      const okendo_summarydata = JSON.parse(summaryData);
      let ratingValue = Number(okendo_summarydata.reviewAverageValue);
      const reviewCount = Number(okendo_summarydata.reviewCount);

      if (reviewCount > 0 && !isNaN(ratingValue) && ratingValue > 0) {
        if (ratingValue < 1) {
          ratingValue = 1.0;
        } else if (ratingValue > 5) {
          ratingValue = 5.0;
        }

        aggregateRating = {
          "@type": "AggregateRating",
          "ratingValue": ratingValue.toFixed(2),
          "reviewCount": reviewCount
        };
      }
    }

    return {
      "@type": "ListItem",
      "position": index + 1,
      "url": product.url,
      "item": {
        "@type": "Product",
        "name": product.name.replace(/"/g, '\\"'),
        "image": product.image_url,
        "description": (product.description || '').replace(/"/g, '\\"'),
        "url": product.url,
        "offers": variantsData(product, aggregateRating),
        "brand": {
          "@type": "Brand",
          "name": "ASTR The Label"
        },
        ...(aggregateRating && { aggregateRating })
      }
    };
  });

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    "name": collection_title,
    "description": collection_description,
    "url": collection_url,
    "mainEntityOfPage": {
      "@type": "CollectionPage",
      "@id": collection_url
    },
    "itemListElement": itemListElement
  };

  const script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.textContent = JSON.stringify(structuredData, null, 2);
  document.head.appendChild(script);

  // console.log('Structured data for collection page:', script);
};
